import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title"];
import * as React from 'react';
export default (function (_ref) {
  var title = _ref.title,
    extra = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement("svg", _extends({
      height: "50",
      width: "27.5",
      viewBox: "0 0 27.5 50"
    }, extra), title, /*#__PURE__*/React.createElement("path", {
      d: "M2.45 0L27.5 25l-25 25-2.45-2.45L22.55 25 0 2.45z"
    }))
  );
});